<div [class.c-toast--green]="toast.type === ToastType.SUCCESS" [class.c-toast--red]="toast.type === ToastType.ERROR" class="c-toast">
	<div class="flex-row flex--space flex-gap--xs">
		<p class="u-text--medium">{{ toast.title | translate }}</p>

		<button (click)="close()" class="c-btn-link">
			<tvcore-icon name="close"></tvcore-icon>
		</button>
	</div>

	@if (toast.message) {
		<p class="u-m-top--xxs">{{ toast.message | translate }}</p>
	}

	@if (toast.detail) {
		<p class="u-text--xs u-m-top--xxs">{{ toast.detail | json }}</p>
	}
</div>
